import { render } from "./AgregarAdministrador.vue?vue&type=template&id=c0227ab0&scoped=true"
import script from "./AgregarAdministrador.vue?vue&type=script&lang=js"
export * from "./AgregarAdministrador.vue?vue&type=script&lang=js"

import "./AgregarAdministrador.vue?vue&type=style&index=0&id=c0227ab0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0227ab0"]])

export default __exports__